import React, { useEffect, useState } from "react";
import { Alert, Col, Row, Spinner } from "react-bootstrap";
import axios from "axios";
import { Link } from "react-router-dom";
import SellerProductsTableComponent from "../../components/tables/Seller/SellerProductsTableComponent";
import PageLayout from "../../layouts/PageLayout";

export default function StoreSellerPendingProductsPage() {
    const [products, setProducts] = useState([]);
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const authHeaders = () => ({
        Authorization: `Bearer ${localStorage.getItem("authToken") || localStorage.getItem("AuthUser") || ""}`,
    });
    
    useEffect(() => {
        let isCurrentRequest = true;

        const fetchPendingProducts = async () => {
            setLoading(true);
            setError("");

            try {
                const response = await axios.get(
                    `${process.env.REACT_APP_API_URL}/store-seller/pending-products`,
                    {
                        headers: authHeaders()
                    }
                );

                if (!isCurrentRequest) return;

                const responseData = response.data?.data;
                const productList = Array.isArray(responseData)
                    ? responseData
                    : Array.isArray(responseData?.data)
                        ? responseData.data
                        : [];

                setProducts(productList);
                setTotal(Number(response.data?.total ?? responseData?.total ?? productList.length));
            } catch (requestError) {
                if (!isCurrentRequest) return;
                console.error("Could not load pending store seller products:", requestError);
                setError(requestError.response?.data?.message || "Could not load pending products.");
            } finally {
                if (isCurrentRequest) setLoading(false);
            }
        };

        fetchPendingProducts();
        return () => {
            isCurrentRequest = false;
        };
    }, []);

    const tableHeaders = [
        "Product Code",
        "Title",
        "Category",
        "Brand",
        "Condition",
        "Buying Price",
        "Quantity",
        "Action",
    ];

    return (
        <PageLayout>
            <Row>
                <Col xl={12}>
                    <div className="mc-card">
                        <div className="mc-breadcrumb">
                            <h3 className="mc-breadcrumb-title">Pending Approval by Admin ({total})</h3>
                            <ul className="mc-breadcrumb-list">
                                <li className="mc-breadcrumb-item">
                                    <Link to="/dashboard" className="mc-breadcrumb-link">Dashboard</Link>
                                </li>
                                <li className="mc-breadcrumb-item">Pending Approval by Admin</li>
                            </ul>
                        </div>
                    </div>
                </Col>

                <Col xl={12}>
                    <div className="mc-card">
                        {error && <Alert variant="danger" className="mb-4">{error}</Alert>}
                        {loading ? (
                            <div className="text-center py-5">
                                <Spinner animation="border" variant="primary" />
                                <p className="mt-2 text-muted">Loading pending products...</p>
                            </div>
                        ) : (
                            <SellerProductsTableComponent
                                thead={tableHeaders}
                                tbody={products}
                                activeTab="pending"
                            />
                        )}
                    </div>
                </Col>
            </Row>
        </PageLayout>
    );
}
